import { render, staticRenderFns } from "./StockFormer.vue?vue&type=template&id=7b7bd9d6&"
import script from "./StockFormer.vue?vue&type=script&lang=js&"
export * from "./StockFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports